type Props = {
  children: React.ReactNode;
};

const FormBlock = ({ children }: Props) => {
  return <div className="flex gap-2">{children}</div>;
};

export default FormBlock;
